import baseAPI from '@/api';
import { Restriction } from '@/models/restriction';
import { UpdateRestrictionRequestDto } from '@/services/dto/restrictions/update-restriction-input.dto';

export async function fetchUpdateRestriction({
  id,
  ...data
}: UpdateRestrictionRequestDto) {
  const response = await baseAPI.patch<Restriction>(
    `/restrictions/${id}`,
    data,
  );
  return response.data;
}
